import "./Dashboard.mobile.css";
import "./Dashboard.css";
import { useDashboardController } from "./dashboard/useDashboardController";
import { DashboardView } from "./dashboard/DashboardView";
import { RefreshCancellation } from "../lib/useRefreshOwner";

export default function Dashboard() {
  const dashboard = useDashboardController();
  if (dashboard.screen === "loading") return <div className="container-x py-20 text-center text-mut">Loading…</div>;
  if (dashboard.screen === "admin") return <div className="container-x py-20 text-center text-mut">Redirecting to Admin…</div>;
  const { dashboardRefresh: refresh } = dashboard;
  return <RefreshCancellation.Provider value={refresh.cancel}>
    <DashboardView {...dashboard} />
  </RefreshCancellation.Provider>;
}
